module.exports = __webpack_public_path__ + "img/edu-6.842785c2.png";